import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Button, EmptyState, Icon } from '@weezevent/nacre';
import { Loader } from 'semantic-ui-react';
import { useLegalEntitiesStore } from './store';
import { DeleteEntityModalProvider } from './deleteEntityModal';
import { EditLegalEntitiesDrawerProvider, useEditLegalEntitiesDrawer } from './editLegalEntitiesDrawer';
import { LegalEntity } from './LegalEntity';
import { LoadingStatus } from '../../store';

export const LegalEntitiesContent = () => {
    const { t } = useTranslation();
    const editDrawer = useEditLegalEntitiesDrawer();
    const { status, legalEntities } = useLegalEntitiesStore();

    const renderContent = () => {
        if (status === LoadingStatus.EMPTY) {
            return (
                <EmptyState
                    title={t('sauron.financeModule.documentHeads.empty')}
                    icon={<Icon margin name="list" size="regular" />}
                    labelButton={t('sauron.financeModule.documentHeads.cta.add')}
                    onClick={editDrawer.create}
                />
            );
        }

        if (status === LoadingStatus.LOADING) {
            return <Loader active inline="centered" />;
        }

        return (
            <>
                {legalEntities?.map((it, index) => (
                    <LegalEntity data={it} key={it.id} isOpenByDefault={index === 0} />
                ))}
                <Button as="button" primary onClick={editDrawer.create}>
                    {t('sauron.financeModule.documentHeads.cta.add')}
                </Button>
            </>
        );
    };

    return (
        <Card>
            <Card.Header>
                <Card.Title>{t('sauron.financeModule.documentHeads.title')}</Card.Title>
            </Card.Header>
            <Card.Content>{renderContent()}</Card.Content>
        </Card>
    );
};

export const LegalEntities = () => {
    return (
        <DeleteEntityModalProvider>
            <EditLegalEntitiesDrawerProvider>
                <LegalEntitiesContent />
            </EditLegalEntitiesDrawerProvider>
        </DeleteEntityModalProvider>
    );
};
